import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '../components/View/LoginView.vue'
import DashboardView from '../components/View/DashboardView.vue'
import KomaView from '../components/UI/koma/mainUI.vue'
import jwt_decode from 'jwt-decode'

const routes = [
  {
    path: '/', component: LoginView, name: "home"
  },
  {
    path: '/dashboard', component: DashboardView, name: "dashboard", meta: {requiresAuth: true}
  },
  {
    path: '/map', component: DashboardView, name: "map", meta: {requiresAuth: true, adminOnly: true}
  },
  {
    path: '/letter', component: DashboardView, name: "letter", meta: {requiresAuth: true}
  },
  {
    path: '/letter-search', component: DashboardView, name: "letter-search", meta: {requiresAuth: true}
  },
  {
    path: '/new-account', component: DashboardView, name: 'new-account', meta: {requiresAuth: true, adminOnly: true}
  },
  {
    path: '/change-role', component: DashboardView, name: 'change-role', meta: {requiresAuth: true, adminOnly: true}
  },
  {
    path: '/profile', component: DashboardView, name: 'profile', meta: {requiresAuth: true}
  },
  {
    path: '/koma', component: KomaView, name: 'koma'
  }
  
]

function titleCase(str) {
  return str.toLowerCase().split('-').map(function(word) {
    return word.replace(word[0], word[0].toUpperCase());
  }).join(' ');
}

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('_rToken')

  if(token) {
    try {
      const decode = jwt_decode(token)
      if(decode.exp*1000 < new Date().getTime()) {
        localStorage.removeItem('_rToken')
        document.title = 'Homepage | MDT Indopride'
        next({path: '/'})
      }
    } catch(err) {
      localStorage.clear()
      document.title = titleCase(to.name) + " | MDT Indopride"
    }
  }

  if(to.meta.requiresAuth) {
    if(token) {
      if(to.meta.adminOnly) {
        try {
          const decode = jwt_decode(token)
          if(decode.roleId >= 5) {
            document.title = titleCase(to.name) + " | MDT Indopride"
            next()
          } else {
            next({path: '/dashboard'})
          }
        }catch(err) {
          if(err) {
            console.error(err)
            next({path: '/dashboard'})
          }
        }
      } else {
        next();
      }
      document.title = titleCase(to.name) + " | MDT Indopride"
    } else {
      document.title = "Home | MDT Indopride"
      next({path: '/'})
    }
  } else if (to.meta.pass) {
    document.title = "Koma | MDT Indopride"
    next();
  } else {
    if(token) {
      document.title = "Dashboard | MDT Indopride"
      next({path: '/dashboard'})
    } else {
      document.title = "Home | MDT Indopride"
      next()
    }
  }
})

export default router